import { Button } from "@mui/material";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import PopAddEditModel from "../components/Model/PopAddEditModel";
import PopAddEditModelHistory from "../components/Model/PopAddEditModelHistory";
import CircularWithValueLabel from '../components/CircularWithValueLabel';
import axiosClient from '../services/axios-client';



const ModelsPage = () => {


    const [models, setModels] = useState([]);
    const [model, setModel] = useState(null);

    const [years, setYears] = useState([]);
    const [year, setYear] = useState(null);


    const [uploading, setUploading] = useState(false);
    const [progress, setProgress] = useState(0);

    const navigate = useNavigate();

    useEffect(() => {

        // get models
        fetch(`${process.env.REACT_APP_API_URL}/model`, { method: 'GET' })
            .then(res => res.json())
            .then(data => setModels(data));


        // get years
        fetch(`${process.env.REACT_APP_API_URL}/model/read-mkey/model_years`, { method: 'GET' })
            .then(res => res.json())
            .then(data => setYears(data));


    }, [])



    const onNewModel = () => {
        setModel({ model_id: 0, model_name: '', model_file: '', model_map: '', model_history: [] });
    }

    const onCloseModel = () => {
        setModel(null);
    }

    const onUpdateModel = (model) => {

        const ar = [...models];

        const index = ar.findIndex((m) => m.model_id == model.model_id);

        if (index >= 0) {
            ar[index] = model;
        } else {
            ar.push(model);
        }

        setModels(ar);
        setModel(null);
    }


    const onNewYear = () => {
        setYear(0);
    }

    const onCloseYear = () => {
        setYear(null);
    }


    const onAddYear = (year) => {

        const ar = [...years];

        if (!ar.includes(year)) {
            ar.push(year);
        }

        ar.sort((a, b) => a - b);

        setYears(ar);

        const body = JSON.stringify({ mkey: 'model_years', mvalue: JSON.stringify(ar) });

        fetch(`${process.env.REACT_APP_API_URL}/model/update-mkey`, {
            body: body,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            }
        }
        )

        setYear(null)
    }


    const uploadAsset = async (e, cb) => {
        let filename = "file.jpg";
        setUploading(true);

        let formData = new FormData();
        formData.append("file", e.target.files[0]);

        axiosClient.post(`${process.env.REACT_APP_API_URL}/upload-file`, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
            onUploadProgress: event => {
                console.log(event.loaded)
                setProgress(100 * event.loaded / event.total);
            }
        }).then((res) => {
            //console.log(res);
            cb(res.data.filename);
            setUploading(false);
        })

    }

    const onDeleteModel = (model) => {
        const isConfirmed = window.confirm("Are you sure you want to delete this model?");
        if (isConfirmed) {
            fetch(`${process.env.REACT_APP_API_URL}/model/${model.model_id}`, { method: 'DELETE' })
                .then(res => res.json())
                .then(data => {
                    const ar = [...models];
                    ar.splice(ar.indexOf(model), 1);
                    setModels(ar);
                });
        }
    }


    const onDeleteYear = (year) => {

        const isConfirmed = window.confirm("Are you sure you want to delete this year?");
        if (isConfirmed) {
            const y = [...years];
            y.splice(y.indexOf(year), 1);

            const body = JSON.stringify({ mkey: 'model_years', mvalue: JSON.stringify(y) });

            fetch(`${process.env.REACT_APP_API_URL}/model/update-mkey`, {
                body: body,
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                }
            }
            )

            setYears(y);
        }
    }

    const goToHotspotsPage = () => {
        window.location.href = "/model";
    }
    

    return (
        <>
            <div>
                Model
            </div>
            <br />
            <br />
            <hr />
            <br />
            <br />
            { /**
         * Models Section
         */}
            <div className="content-header pb-6 flex justify-between">
                <div className="content-header-label">Models</div>
                <div className="content-header-actions">
                    <Button onClick={onNewModel} variant="contained" color="primary">Add New Model</Button>
                </div>
            </div>
            <div className="content-body">

                <table className="table-auto border w-full">
                    <thead>
                        <tr>
                            <th className="font-bold p-2 border-b text-left w-2">No</th>
                            <th className="font-bold p-2 border-b text-left w-full">Model Name</th>
                            <th className="font-bold py-2 px-4 border-b text-left">Actions</th>
                        </tr>
                    </thead>
                    <tbody>

                        {models.map((model, i) => <tr key={i}>
                            <td className="p-2 border-b text-left">{i + 1}</td>
                            <td className="p-2 border-b text-left">{model.model_name}</td>
                            <td className="py-2 px-4 border-b text-left"> <div className="flex flex-row"><Button onClick={() => { setModel(model) }}>Edit</Button> / <Button onClick={() => { onDeleteModel(model) }}>Delete</Button></div> </td>
                        </tr>)}

                    </tbody>
                </table>
            </div>
            <div className="mt-4 flex flex-row justify-end">
                <Button variant="contained" color="secondary" onClick={goToHotspotsPage}>Place Hotspots</Button>
            </div>
            <br />
            <br />
            <hr />
            <br />
            <br />
            {/**
                 * End Models Section
                 */}

            {/**
                 * History Section
                 */}
            <div className="content-header pb-6 flex justify-between">
                <div className="content-header-label">History</div>
                <div className="content-header-actions">
                    <Button onClick={onNewYear} variant="contained" color="primary">Add Year</Button>
                </div>
            </div>
            <div className="content-body">

                <table className="table-auto border w-full">
                    <thead>
                        <tr>
                            <th className="font-bold p-2 border-b text-left w-2">No</th>
                            <th className="font-bold p-2 border-b text-left w-full">History</th>
                            <th className="font-bold py-2 px-4 border-b text-left">Actions</th>
                        </tr>
                    </thead>
                    <tbody>

                        {years.map((year, i) => <tr key={i}>
                            <td className="p-2 border-b text-left">{i + 1}</td>
                            <td className="p-2 border-b text-left">{year}</td>
                            <td className="py-2 px-4 border-b text-left"> <Button onClick={() => onDeleteYear(year)} >Delete</Button> </td>
                        </tr>)}

                    </tbody>
                </table>
            </div>
            <br />
            <br />
            <hr />
            <br />
            <br />
            
            {model && <PopAddEditModel model={model} onUpdateModel={onUpdateModel} onCloseModel={onCloseModel} years={years} uploadAsset={uploadAsset} />}
            {year === 0 && <PopAddEditModelHistory year={year} onAddYear={onAddYear} onCloseYear={onCloseYear} />}
            {uploading && <CircularWithValueLabel progress={progress} />}

        </>
    )
}

export default ModelsPage;